import React from 'react';

import dayjs from 'dayjs-ext';

import propTypes from 'prop-types';
import { UiTable } from '../../ui';
import { DATE_SMONTH_DAY_SYEAR } from '../../ui/const';

// eslint-disable no-unused-expressions
/* eslint-disable react/prop-types */
export function InsuranceLogTable({ data }) {
  const tableColumns = [
    {
      Header: 'Log Id',
      accessor: 'id',

      Cell: row => <div className="has-text-centered">{row.value}</div>,
    },

    {
      Header: 'Total Submitted',
      accessor: 'numberOfPeople',
      Cell: row => <div className="has-text-centered">{row.value}</div>,
    },
    {
      Header: 'Date Submitted',
      accessor: 'submitDate',
      filterable: false,
      Cell: row => (
        <div className="has-text-centered">
          {row.value ? dayjs(row.value).format(DATE_SMONTH_DAY_SYEAR) : null}
        </div>
      ),
    },
  ];

  return (
    <>
      <UiTable
        className="transactions-table -striped -highlight"
        columns={tableColumns}
        data={data}
        useTablePagination
        resolveData={data =>
          data.map(transaction => ({
            ...transaction,
          }))
        }
        getTheadThProps={(_state, _rowInfo, column) => {
          if (column.id === 'amount') {
            return { className: 'has-text-right' };
          }
          if (column.id !== 'date') {
            return { className: 'has-text-left' };
          }
          return { className: '' };
        }}
        SubComponent={row => {
          return (
            <div style={{ padding: '20px', background: 'inherit' }}>
              <UiTable
                data={row.original.people}
                title="Insurance sub table"
                columns={[
                  {
                    Header: 'Name',
                    accessor: 'name',
                    sortable: false,
                    Cell: row => (
                      <div className="has-text-centered">{row.value}</div>
                    ),
                  },

                  {
                    Header: 'Family Size',
                    accessor: 'familySize',
                    Cell: row => (
                      <div className="has-text-centered">{row.value}</div>
                    ),
                    sortable: false,
                  },
                ]}
                showPagination={false}
                hideButton
                hideNext
                hidePrev
              />
            </div>
          );
        }}
        title="Transaction"
        filterable
        hideButton
        hideNext
        hidePrev
      />
    </>
  );
}

InsuranceLogTable.propTypes = {
  data: propTypes.arrayOf(propTypes.object).isRequired,
};
